export default __webpack_public_path__ + "static/Roboto-Regular-04b605aa85f24816e3e6cc19b10c3d09.ttf";